import { SnowplowSearchFilterItem } from "@themuse/snowplow-js-client";
import { SearchFilters } from "../interfaces/context/searchContextInterfaces";

const snowplowFilterNameMap = new Map<string, string>();
snowplowFilterNameMap
    .set("category", "Job Category")
    .set("companyLeadership", "Diversity & Inclusion")
    .set("companySize", "Company Size")
    .set("experienceLevel", "Experience Level")
    .set("industry", "Company Industry")
    .set("perks", "Perks & Benefits")
    .set("postedDateRange", "Date Posted")
    .set("radius", "Search Radius")
    .set("company", "Company Name")
    .set("location", "Location");

export const buildSnowplowFilterItems = (filters: SearchFilters, location?: string, company?: string) => {
    const items: SnowplowSearchFilterItem[] = [];
    const modifiedFilters = { ...filters };
    if (location) {
        Object.assign(modifiedFilters, { location: [location] });
    }
    if (filters.location && !location) {
        delete modifiedFilters.location;
    }
    if (company) {
        Object.assign(modifiedFilters, { company: [company] });
    }
    if (filters.company && !company) {
        delete modifiedFilters.company;
    }
    Object.keys(modifiedFilters).forEach((key) => {
        if (!snowplowFilterNameMap.get(key) || !modifiedFilters[key].length) return;
        if (Array.isArray(modifiedFilters[key])) {
            modifiedFilters[key].forEach((val: string) => {
                items.push({
                    filter_name: snowplowFilterNameMap.get(key),
                    filter_value: val
                });
            });
        } else {
            items.push({
                filter_name: snowplowFilterNameMap.get(key),
                filter_value: modifiedFilters[key]
            });
        }
    });
    return items;
};
